











































































































































































import {Component, Vue} from 'vue-property-decorator';
import {MutationTypes} from '@/store/mutations/types';
import {Mutation} from 'vuex-class';
import moment from 'moment';


@Component
export default class QuestFlagView extends Vue {
  /*昵称选项*/
  private shareName: 'realName' | 'nickName' | 'noneName' | '' = '';
  /*是否愿意*/
  private share: string | number = '' || 0;
  /*表单详情*/
  private flagInfo = {
    mobile: '',
    name: '',
    wish: '',
    nickName: '',
    type: 1,
    plan: ''
  };

  @Mutation(MutationTypes.QUESTIONNAIRE_FLAG_CONTENT_SAVE)
  public flagSave: any;

  mounted() {
  }

  /**
   * 提交前的校验
   */
  public checkForm(): boolean {
    if (!this.flagInfo.mobile) {
      this.$message.warn('请输入手机号码');
      return false;
    } else if (!/^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(this.flagInfo.mobile)) {
      this.$message.warn('请输入正确的手机号码');
      return false;
    }

    if (!this.flagInfo.name) {
      this.$message.warn('请输入姓名');
      return false;
    }
    if (!this.flagInfo.wish) {
      this.$message.warn('请输入愿望内容');
      return false;
    } else if (this.flagInfo.wish.length > 24) {
      this.$message.warn('内容过长');
      return false;
    }
    if (!this.flagInfo.plan) {
      this.$message.warn('请输入实现计划');
      return false;
    }
    if (this.share == 1 && this.shareName == 'nickName') {
      if (this.flagInfo.nickName === '') {
        this.$message.warn('请输入显示昵称');
        return false;
      }
    }
    return true;
  }

  /**
   * 提交表单
   */
  public submitForm() {
    this.$nextTick(() => {
      if (!this.checkForm()) {
        return;
      }
      let name: string = '';
      this.axios.post(
        '/api/questionnaire',
        {
          mobile: this.flagInfo.mobile,
          name: this.flagInfo.name,
          json: JSON.stringify({
            '愿望内容': this.flagInfo.wish,
            '实现计划': this.flagInfo.plan,
            '实现时间': moment(new Date()).year(2021).month(11).date(31).hour(23).minute(59).second(59).format('YYYY-MM-DD'),
            '昵称': this.flagInfo.nickName,
            '是否分享': this.share ? '是' : '否',
            '是否匿名': (this.shareName == 'noneName') ? '是' : '否'
          }),
          type: 1
        }).then((res: any) => {
        this.flagSave(this.flagInfo.wish);
        this.$router.push({name: 'flag-info', params: {text: this.flagInfo.wish}});
      });


    });

  }
}
